import React, { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import AdminLayout from 'layouts/Admin.js';
import AuthLayout from 'layouts/Auth.js';
import PrivateRoute from './components/PrivateRoute/PrivateRoute.js';
import Notifier from './components/Notifier';
import ErrorFallback from 'components/ErrorFallback';
import VolunteerSignup from 'layouts/VolunteerSignup.js';
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase';
import MaintenanceMode from 'views/Pages/MaintenanceMode.js';
import { useSelector } from 'react-redux';

const App = () => {
  const db = useFirestore();
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(null);
  const authedMaintenanceMode = useSelector(
    state => state.firestore.data.configs?.crAppRemoteConfig?.data?.maintenanceMode,
  );

  console.log('isMaintenanceMode', isMaintenanceMode);

  useEffect(() => {
    db.collection('configs')
      .doc('crAppRemoteConfig')
      .get()
      .then(doc => {
        const config = doc.data();
        setIsMaintenanceMode(config.data?.maintenanceMode ?? false);
      });
  }, [db]);

  /**
   * Load configs into redux here for the whole app instead of that route level. It will fail
   * unless the user is authenticated and has access to the configs collection.
   */
  useFirestoreConnect({
    collection: 'configs',
    storeAs: 'configs',
  });

  if (isMaintenanceMode === null) {
    return null;
  }

  if (isMaintenanceMode || authedMaintenanceMode) {
    return <MaintenanceMode />;
  }

  return (
    <Sentry.ErrorBoundary fallback={() => <ErrorFallback />} showDialog>
      <Notifier />
      <Router>
        <Switch>
          <Route path="/signup" component={AuthLayout} />
          <Route path="/auth" component={AuthLayout} />
          <Route path="/volunteer-signup/:projectId" component={VolunteerSignup} />
          <PrivateRoute path="/admin" component={AdminLayout} />
          <Redirect from="/" to="/admin" />
        </Switch>
      </Router>
    </Sentry.ErrorBoundary>
  );
};

export default App;
